import { MORE_1024_MEDIA_QUERY, MORE_768_MEDIA_QUERY } from '../../../consts/adaptive';

export const styles = {
    container: {
        background: '#FFFFFF',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 20,
    },
    ssrWrap: {
        padding: 12,
        height: 62,
        boxSizing: 'border-box',
        backgroundColor: '#fff'
    },
    ssrMap: {
        display: 'none'
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '20px',
        color: '#0087BE',
    },
    map: {
        height: 420
    },
    openButton: {
        margin: '0 auto',
        width: '100%',
        padding: [8, 16],
        textAlign: 'center',
        boxSizing: 'border-box',
        border: '1px solid #0087BE',
        borderRadius: 4,
        backgroundColor: '#fff',
        cursor: 'pointer',
    },
    openerBlockWrapper: {
        marginLeft: '-16px',
    },
    icon: {
        marginTop: 6,
        float: 'right',
        transform: 'rotate(180deg)'
    },
    fullScreenMap: {
        height: 'calc(100vh - 60px)'
    },

    [MORE_768_MEDIA_QUERY]: {
        container: {
            background: '#F3F9FF',
            padding: [48, 0]
        },
        ssrWrap: {
            padding: 0,
            height: 'auto',
            backgroundColor: 'transparent'
        },
        ssrMap: {
            display: 'block',
            height: 420
        },
        title: {
            float: 'none',
            marginBottom: 20,
            fontSize: 20
        }
    },

    [MORE_1024_MEDIA_QUERY]: {
        container: {
            padding: [48, 0]
        },
        map: {
            height: 560
        },
        ssrMap: {
            height: 560
        }
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
